import Vue from 'vue';
import VueResource from 'vue-resource';
Vue.use(VueResource);
export default({});



// WEBPACK FOOTER //
// ./src/resource/index.js